<script>
    import {vIcon} from '@/components/form';
    import _ from '@/common/helpers';

    export default {
        name: 'group-header',
        props: {
            lineage: String,
        },
        render(createElement) {
            return createElement('h3', _.separateArray(
                this.lineage.replace(/^\//, '')
                    .split('/').map(this.$filters.unCamelCase),
                createElement(vIcon, {props: {icon: 'caret-right'}}),
            ));
        },
    };
</script>
